import {Directive} from '@angular/core';
import {AbstractControl, NG_VALIDATORS, ValidationErrors, Validator} from '@angular/forms';

@Directive({
  standalone: true,
  selector: '[pubJsonValidator]',
  providers: [
    {provide: NG_VALIDATORS, useExisting: JsonValidatorDirective, multi: true}
  ]
})
export class JsonValidatorDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors | null {
    if (!control.value) {
      return null; // Empty values are handled by required validator
    }
    try {
      JSON.parse(control.value);
      return null;
    } catch (e) {
      let message = 'Invalid JSON format';
      if (e instanceof SyntaxError) {
        message = e.message;
      }
      return {invalidJson: {message}};
    }
  }
}
